// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"97":"ece69cdd","703":"9974a4a1","765":"ad1c6f98"}[chunkId] + ".css";
};